module.exports = __webpack_public_path__ + "static/media/Logo_Brebeuf.10c219b7.jpg";